import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-378">
    {children}
  </motion.div>;
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export const CTAButton = ({
  href,
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) => {
  return <a href={href} className={`
        inline-flex items-center justify-center gap-2 transition-all duration-300
        ${fullWidth ? 'w-full' : ''}
        ${variant === 'primary' ? 'bg-brandOrange text-white font-sans font-extrabold uppercase tracking-wide text-base px-9 py-4 rounded-[14px] shadow-[0_0_30px_rgba(255,107,0,0.45),0_4px_16px_rgba(255,107,0,0.35)] hover:bg-brandOrange-hover hover:-translate-y-0.5 hover:shadow-[0_0_50px_rgba(255,107,0,0.6)] animate-glow-button' : 'bg-bg-card text-txt-primary font-bold border border-line hover:bg-bg-highlight hover:border-gray-600 text-[15px] px-8 py-4 rounded-[14px]'}
        ${className}
      `} data-id="element-379">
      {children}
    </a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-12 md:py-20 px-6 overflow-hidden ${className}`} data-id="element-380">
    <div className="max-w-[1100px] mx-auto" data-id="element-381">{children}</div>
  </section>;